import React, { Fragment, useMemo } from "react";
import { Checkbox, Form, DropdownProps, Input, Divider } from "semantic-ui-react";
import { WidgetProps } from '@rjsf/core';
import { useTranslation } from "react-i18next";
import { isRowList } from "../util/rows";
import { schemaToRows } from "../../../schema.helpers";
import { useSchemaTranslation } from "../../../useSchemaTranslation";

type TValue = { [key: string]: boolean }

export const ToggleList: React.FC<WidgetProps> = (props) => {

    const { t } = useSchemaTranslation();
    const { onChange, value = {}, options, schema } = props;

    const shouldTranslate = !options.translations || (options as any).translations.rows !== false

    if (!isRowList(options.rows) && !schema.properties) {
        throw new Error(`Invalid row list for toggleList`);
    }




    const rows = useMemo(() => {
        const getLabel = (subSchema: any) => shouldTranslate ? subSchema.title : subSchema.title;
        let rows = schemaToRows(schema, getLabel);
        if (!rows) {
            rows = (options as any).rows.map((row: DropdownProps) => {
                if (shouldTranslate) {
                    return { ...row, text: t(row.text) };
                }
                return row;
            });
        }

        return rows as { text: string, value: string }[];

    }, [schema, t, shouldTranslate, options])


    const items = rows;

    const ensureValues: TValue = useMemo(
        () => {
            return items.reduce((ensured, item): TValue => {
                if (typeof ensured[item.value] === "undefined") {
                    return { ...ensured, [item.value]: false };
                }
                return ensured;
            }, value);
        },
        [value, items],
    );

    const checkboxClicked = (name: string, value: boolean) => {
        onChange({
            ...ensureValues,
            [name]: value,
        });
    };



    return (
        <Fragment>
            {
                items.map((item) => (
                    <Form.Field key={item.value}>
                        <Checkbox
                            toggle={!options.showAsCheckbox}
                            checked={ensureValues[item.value]}
                            label={t(item.text)}
                            onChange={(_, { checked }) => checkboxClicked(item.value, !!checked)}
                        />
                    </Form.Field>
                ))
            }

        </Fragment>
    );
};
